import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import SecureNewClient from './SecureNewClient';
import { useApplicationStore } from './applicationStore';

const SecureNewClientPage = () => {
	const { getClient, skipAccountCreation, program } = useApplicationStore();
	const [isStubbedAccountValid, setIsStubbedAccountValid] = useState(false);
	const [updateAppStore, setUpdateAppStore] = useState(false);
	const navigate = useNavigate();
	useEffect(() => {
		if (updateAppStore) {
			if (program) {
				navigate('/newApplication/confirm');
			} else {
				navigate('/newApplication/search');
			}
		}
	}, [updateAppStore]);

	if (!getClient().name_last && !getClient().name_first) {
		return <Navigate to="/newApplication/profile" replace />;
	}

	const handleNext = () => {
		setUpdateAppStore(true);
	};

	return (
		<>
			<h1>Secure Profile</h1>
			<div className="secure-account">
				<SecureNewClient
					onValidated={setIsStubbedAccountValid}
					updateAppStore={updateAppStore}
				/>
			</div>
			<div className="grid grid-cols-2">
				<div></div>
				<div className="flex justify-end">
					<button
						className="btn btn-primary btn-wide"
						disabled={!skipAccountCreation && !isStubbedAccountValid}
						onClick={handleNext}
					>
						Next
					</button>
				</div>
			</div>
		</>
	);
};

export default SecureNewClientPage;
